// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Xzu8f","wrapperInactive":"styles_wrapperInactive__DrU8p","text":"styles_text__Sww8V"};